export const STATUS_OPTIONS = [
  { value: 'lajang', label: 'Lajang' },
  { value: 'menikah', label: 'Menikah' },
  { value: 'duda-janda', label: 'Duda/Janda' }
];

export const PENGALI_USIA = [
  { min: 25, max: 30, faktor: 20 },
  { min: 31, max: 35, faktor: 18 },
  { min: 36, max: 40, faktor: 15 },
  { min: 41, max: 45, faktor: 12 },
  { min: 46, max: 50, faktor: 10 },
  { min: 51, max: 100, faktor: 8 }
];

export const PREMI_INDIKATIF = [
  { usia: '25-30', '500jt': 900000, '1M': 1600000, '1.5M': 2300000, '2M': 3000000, '2.5M': 3700000 },
  { usia: '31-35', '500jt': 1200000, '1M': 2100000, '1.5M': 3000000, '2M': 3900000, '2.5M': 4800000 },
  { usia: '36-40', '500jt': 1600000, '1M': 2800000, '1.5M': 4000000, '2M': 5200000, '2.5M': 6400000 },
  { usia: '41-45', '500jt': 2200000, '1M': 3800000, '1.5M': 5400000, '2M': 7000000, '2.5M': 8600000 },
  { usia: '46-50', '500jt': 3000000, '1M': 5200000, '1.5M': 7400000, '2M': 9600000, '2.5M': 11800000 },
  { usia: '>50', '500jt': 4500000, '1M': 7500000, '1.5M': 10500000, '2M': 13500000, '2.5M': 16500000 }
];

export const REKOMENDASI_PRODUK = [
  { minUsia: 18, maxUsia: 40, produk: 'Term Life atau Unit Link' },
  { minUsia: 41, maxUsia: 50, produk: 'Kombinasi Term Life + Whole Life' },
  { minUsia: 51, maxUsia: 100, produk: 'Whole Life' }
];